































import { Prop, Vue, Component } from "vue-property-decorator";
@Component({
  name: "displayItem",
})
export default class extends Vue {
  @Prop() list!: any[];
  @Prop() rootHeight!: number;
  @Prop() dragStartHandle!: Function;
  handleDragStart(e: any, lesson: any) {
    this.dragStartHandle(e, lesson);
  }
}
